import { Popper } from "@mui/material";
import { styled } from "@mui/material/styles";

/** Above nested GoMakeDialog modals (e.g. production-floor proofing flows). */
export const NESTED_MODAL_AUTOCOMPLETE_Z_INDEX = 1_000_000_001;

const NestedModalAutocompletePopper = styled(Popper)(() => ({
  zIndex: NESTED_MODAL_AUTOCOMPLETE_Z_INDEX,
  "&[data-popper-placement]": {
    width: "var(--popper-anchor-width)",
  },
  "& .MuiAutocomplete-paper": {
    zIndex: NESTED_MODAL_AUTOCOMPLETE_Z_INDEX,
    width: "var(--popper-anchor-width)",
    minWidth: "var(--popper-anchor-width)",
  },
  "& .MuiAutocomplete-listbox": {
    zIndex: NESTED_MODAL_AUTOCOMPLETE_Z_INDEX,
    width: "100%",
  },
}));

const getNestedModalAutocompleteProps = () => ({
  disablePortal: false as const,
  PopperComponent: NestedModalAutocompletePopper,
  componentsProps: {
    popper: {
      sx: {
        zIndex: `${NESTED_MODAL_AUTOCOMPLETE_Z_INDEX} !important`,
      },
      style: {
        zIndex: NESTED_MODAL_AUTOCOMPLETE_Z_INDEX,
      },
      modifiers: [
        {
          name: "offset",
          options: {
            offset: [0, 4],
          },
        },
        {
          name: "preventOverflow",
          enabled: true,
        },
        {
          name: "flip",
          enabled: false,
        },
      ],
    },
  },
});

export {
  NestedModalAutocompletePopper,
  getNestedModalAutocompleteProps,
};
